import React, { useEffect, useState } from 'react';
import Login from './Login';
import { IConfig } from '../Interfaces/IConfig';
import { LoadingSpinner } from './LoadingSpinner';

interface IProps {
  msg?: string;
  children: React.ReactElement;
  configObject: IConfig;
}

const SecurityDriver: React.FC<IProps> = props => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLogged, setIsLogged] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  useEffect(() => {
    const sessionToken = localStorage.getItem('SessionToken');

    if (sessionToken === '' || sessionToken === null) {
      setIsLogged(false);
      setIsLoading(false);
    } else {
      fetch('/api/oauth', {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('SessionToken'),
        },
      })
        .then(async res => {
          if (res.status == 200) {
            // Scope frisch aus dem Backend übernehmen — sonst behält der
            // localStorage stale Werte (z. B. wenn neue Permissions wie
            // „reports" nach dem letzten Login eingeführt wurden).
            try {
              const data = await res.clone().json();
              if (Array.isArray(data?.scope)) {
                localStorage.setItem('scope', data.scope.join(','));
              }
            } catch {
              /* JSON-Parse-Fehler ignorieren — der Token ist gültig, das reicht. */
            }
            setIsLogged(true);
            setIsLoading(false);
          } else {
            throw Error(String(res.status));
          }
        })
        .catch(error => {
          if (String(error).includes('401')) {
            setMsg('Ihre Session ist abgelaufen.');
          } else if (String(error).includes('404')) {
            setMsg(
              'Die Anmeldedaten konnten nicht gefunden werden. Bitte überprüfen Sie den Anmeldename und das Passwort'
            );
          } else if (String(error).includes('403')) {
            setMsg(`Ihr Konto wurde deaktiviert!`);
          } else {
            setMsg(
              `Es ist ein unbekannter Fehler aufgeretten. Möglicherweise ist der Dienst vorübergehend offline.`
            );
          }
          setIsLogged(false);
          setIsLoading(false);
        });
    }
  }, []);

  if (isLoading) {
    return <LoadingSpinner height='100vh' />;
  } else if (isLogged) {
    return props.children;
  } else {
    return <Login msg={msg} configObject={props.configObject} />;
  }
};
export default SecurityDriver;
